"use client";

import * as React from "react";
import { cn } from "@/utils/utils";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "./card";

export type SectionCardProps = React.HTMLAttributes<HTMLDivElement> & {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  headerClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
};

export function SectionCard({
  header,
  footer,
  children,
  className,
  headerClassName,
  contentClassName,
  footerClassName,
  ...rest
}: SectionCardProps) {
  return (
    <Card className={className} {...rest}>
      {header != null ? (
        <CardHeader className={headerClassName}>
          {header}
        </CardHeader>
      ) : null}

      <CardContent className={contentClassName}>
        {children}
      </CardContent>

      {footer != null ? (
        <CardFooter className={footerClassName}>
          {footer}
        </CardFooter>
      ) : null}
    </Card>
  );
}